module.exports = __webpack_public_path__ + "img/myaccount-banner.bdd2cca5.jpg";